/**
 * Whether this workbook counts dates from 1904 rather than 1900.
 *
 * Office.js exposes no property for it, so it is read off Excel's own DATE:
 * 1 January 2000 is serial 36526 in the 1900 system and 35064 in the 1904 one.
 * The backend needs it to read a date cell passed as a year, month or day
 * parameter; without it a 1904 workbook's dates land four years early.
 * A failed read is not remembered, so the next request tries again.
 */

const SERIAL_2000_01_01_IN_1904 = 35064;

let known: Promise<'1904' | undefined> | null = null;

export function workbookDateSystem(): Promise<'1904' | undefined> {
  if (!known) {
    known = Excel.run(async context => {
      const result = context.workbook.functions.date(2000, 1, 1);
      result.load('value');
      await context.sync();
      return result.value === SERIAL_2000_01_01_IN_1904 ? '1904' as const : undefined;
    }).catch(() => {
      known = null;
      return undefined;
    });
  }
  return known;
}
